import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/useAuth";

const PublicRoute = ({ children }) => {
  const { token, loading } = useAuth();
  const location = useLocation();

  if (loading) return <div>Loading...</div>;

  const authPaths = ["/login", "/signup", "/forgot-password", "/reset-password"];

  // If user is logged in and tries to visit login/signup pages → redirect to dashboard
 if (token && authPaths.includes(location.pathname)) {
  return <Navigate to="/" replace />;
 }

  return children;
};

export default PublicRoute;